import p from './customer-account-manage.vue';

export default p;
